var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-12" },
    [
      _c("span", { staticClass: "timestamp-hour" }, [
        _vm._v(_vm._s(_vm.transaction_data.log_time))
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "message-bg" },
        [
          _vm.transaction_data.action_metadata &&
          _vm.transaction_data.action_metadata.action_name &&
          _vm.transaction_data.action_metadata.action_name !== ""
            ? [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.transaction_data.action_metadata.action_name)
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _vm.transaction_data.action_metadata.entity_name &&
                _vm.transaction_data.action_metadata.entity_name !== ""
                  ? [
                      _c("span", [
                        _vm._v(
                          "Entity: " +
                            _vm._s(
                              _vm.transaction_data.action_metadata.entity_name
                            )
                        )
                      ]),
                      _c("br")
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.transaction_data.action_metadata.domain_name &&
                _vm.transaction_data.action_metadata.domain_name !== ""
                  ? [
                      _c("span", [
                        _vm._v(
                          "Domain: " +
                            _vm._s(
                              _vm.transaction_data.action_metadata.domain_name
                            )
                        )
                      ]),
                      _c("br")
                    ]
                  : _vm._e()
              ]
            : [
                _c("span", { staticClass: "target" }, [_vm._v("Type: ")]),
                _vm._v(" "),
                _c("span", { staticClass: "message" }, [
                  _vm._v(_vm._s(_vm.transaction_data.action_type))
                ]),
                _c("br")
              ],
          _vm._v(" "),
          _c("span", [
            _vm._v("Status:\n            "),
            _c(
              "span",
              { class: _vm.transaction_data.status_class },
              [
                _vm.isStatus(
                  _vm.transaction_status_codes.LOG_STATUS_IN_PROGRESS,
                  _vm.transaction_data.status_code
                )
                  ? [_c("fa", { attrs: { icon: "spinner", spin: "" } })]
                  : _vm._e(),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.transaction_data.status) +
                    "\n            "
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", [
            _c("em", [_vm._v("by: " + _vm._s(_vm.transaction_data.username))])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("h5", [_vm._v("Transactions")]),
          _vm._v(" "),
          _vm.has_data === false
            ? [_vm._v("\n          Loading details, please wait ...\n        ")]
            : [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    hover: "",
                    items: _vm.transactions,
                    fields: _vm.table_fields,
                    "sort-by": "id",
                    "sort-desc": true,
                    "show-empty": true,
                    "empty-text": "There are no transactions available."
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(transaction_id)",
                      fn: function(data) {
                        return [
                          _vm._v(
                            "\n                  " +
                              _vm._s(data.item.id) +
                              "\n              "
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(transaction_name)",
                      fn: function(data) {
                        return [
                          data.item.has_fetch_error
                            ? [_vm._v("error reading transaction")]
                            : [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      data.item.transaction_metadata
                                        .transaction_name
                                    ) +
                                    "\n                  "
                                )
                              ]
                        ]
                      }
                    },
                    {
                      key: "cell(transaction_details)",
                      fn: function(data) {
                        return [
                          data.item.has_fetch_error
                            ? [_vm._v(_vm._s(data.item.fetch_error_text))]
                            : [
                                data.item.transaction_metadata.entity_name
                                  ? [
                                      _vm._v(
                                        "Entity: " +
                                          _vm._s(
                                            data.item.transaction_metadata
                                              .entity_name
                                          )
                                      ),
                                      _c("br")
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                data.item.transaction_metadata.domain_name
                                  ? [
                                      _vm._v(
                                        "Domain: " +
                                          _vm._s(
                                            data.item.transaction_metadata
                                              .domain_name
                                          )
                                      ),
                                      _c("br")
                                    ]
                                  : _vm._e()
                              ]
                        ]
                      }
                    },
                    {
                      key: "cell(status)",
                      fn: function(data) {
                        return [
                          _vm._v(
                            "\n                  " +
                              _vm._s(data.item.status) +
                              "\n              "
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(show_details)",
                      fn: function(row) {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { size: "sm" },
                              on: { click: row.toggleDetails }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(row.detailsShowing ? "Hide" : "Show") +
                                  " Details\n                "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "row-details",
                      fn: function(row) {
                        return [
                          _c(
                            "b-card",
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-sm-right",
                                      attrs: { sm: "3" }
                                    },
                                    [_vm._v("Step")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-col", [_vm._v("Status")]),
                                  _vm._v(" "),
                                  _c("b-col", [_vm._v("Duration")]),
                                  _vm._v(" "),
                                  _c("b-col", [_vm._v("Details")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                row.item.transaction_metadata.transaction_steps,
                                function(transaction_step) {
                                  return _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-sm-right",
                                          attrs: { sm: "3" }
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(transaction_step.name)
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          transaction_step.needed === 0
                                            ? [
                                                _vm._v(
                                                  "\n                        not required\n                      "
                                                )
                                              ]
                                            : [
                                                transaction_step.status === 1
                                                  ? [
                                                      _vm._v(
                                                        "\n                          success\n                        "
                                                      )
                                                    ]
                                                  : transaction_step.status ===
                                                    0
                                                  ? [
                                                      _vm._v(
                                                        "\n                          fail\n                        "
                                                      )
                                                    ]
                                                  : [
                                                      transaction_step.start ===
                                                      -1
                                                        ? [
                                                            _vm._v(
                                                              "\n                            not started\n                          "
                                                            )
                                                          ]
                                                        : [
                                                            transaction_step.progress >
                                                              0 &&
                                                            transaction_step.progress <
                                                              100
                                                              ? [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        transaction_step.progress
                                                                      ) +
                                                                      "%\n                            "
                                                                  )
                                                                ]
                                                              : [
                                                                  _vm._v(
                                                                    "\n                              in progress\n                            "
                                                                  )
                                                                ]
                                                          ]
                                                    ]
                                              ]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          transaction_step.needed === 1
                                            ? [
                                                transaction_step.status === 1
                                                  ? [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            transaction_step.end -
                                                              transaction_step.start
                                                          ) +
                                                          "s\n                        "
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _vm._v(_vm._s(transaction_step.data))
                                      ])
                                    ],
                                    1
                                  )
                                }
                              )
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("action-log-details-ccs-modal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }